import React from 'react'
import PropTypes from 'prop-types'
import Ad from './components/Ad'
import PlaceholderImage from './components/PlaceholderImage'

function getAd(campaigns, activeAd, onClick) {
    // Make sure that campaigns have been fetched before trying to get the images
    if (campaigns === undefined || campaigns.length < 1) {
        return <PlaceholderImage empty />
    }

    // If active ad is missing return nothing
    if (campaigns[activeAd] == null) return <PlaceholderImage empty />

    return <Ad {...campaigns[activeAd]} onClick={() => onClick(campaigns[activeAd].link)} />
}

const AdViewer = (props) => {
    const ad = getAd(props.campaigns, props.activeAd, props.onClick)
    return <div>{ad}</div>
}

AdViewer.propTypes = {
    activeAd: PropTypes.number,
    campaigns: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            src: PropTypes.string,
            link: PropTypes.string,
        }),
    ),
    onClick: PropTypes.func,
}

export default AdViewer



// WEBPACK FOOTER //
// ./src/features/Creatives/components/Feed/components/Viewer/index.js